import styled, { css } from 'styled-components';
import Text from '../Text';
export const StyledDropdownItem = css(["cursor:pointer;display:block;width:100%;padding:var(--size-spacing-02) var(--size-spacing-04);", " ", ""], _ref => {
  let {
    disabled
  } = _ref;
  return !disabled && css(["&:hover,&:active,&:focus,&:focus-within,&:focus-visible{outline:none;background:var(--neutral-surface-hover);}"]);
}, _ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled && css(["pointer-events:none;&,", "{color:var(--neutral-text-disabled);}"], Text.Style);
});
const ARROW_HEIGHT = '14px';
const ARROW_SHADOW_BLUR = '4px';
export const StyledArrow = styled.span.withConfig({
  displayName: "sharedStyles__StyledArrow",
  componentId: "sc-wsllt2-0"
})(["width:", ";height:", ";&:before{content:'';background-color:var(--neutral-surface);display:block;width:", ";height:", ";transform:rotate(45deg);box-shadow:0 0 ", " rgba(33,36,41,0.1);}&:after{content:'';position:absolute;background-color:var(--neutral-surface);}"], ARROW_HEIGHT, ARROW_HEIGHT, ARROW_HEIGHT, ARROW_HEIGHT, ARROW_SHADOW_BLUR);

/**
 * Used to positioning the arrow correctly and not have scrolling.
 */
export const StyledContainerWithArrow = styled.div.withConfig({
  displayName: "sharedStyles__StyledContainerWithArrow",
  componentId: "sc-wsllt2-1"
})(["padding:var(--size-spacing-05);position:relative;overflow:hidden;"]);